import React, { useEffect, useState } from "react";
import { ArrowRightFromLine, Asterisk, Delete, Eye, Notebook, NotebookPen, Pen, Quote, TrendingUp, User, UserPen } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import CompanyTenderForm from "./tender_form";
import { createTender, deleteTender, fetchTenders, updateTender } from "../../../slices/company/tenderSlice";
import { fetchCustomers } from "../../../slices/company/customerSlice";
import { fetchFinalProducts } from "../../../slices/company/finalProductSlice";
import moment from "moment/moment";
import { getProducts } from "../../../slices/company/rawProductSlice";
import TenderRawProducts from "./tender_raw_products";
import CustomerDetailModal from "./customer_detail";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import CreateTaskModal from "./task_modal";
import { createTask } from "../../../slices/company/taskSlice";
import ShowStagesModal from "./showStages";
import QuotationDetailModel from "./quotation_detail";
import NoteViewModal from "./note_modal";
import { customTableStyles } from "../../../utils/tableStylings";

const CompanyTenders = () => {
    const dispatch = useDispatch();
    const { type } = useParams();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [showModalCustomer, setShowCustomerModal] = useState(false); // To control modal visibility
    const [showRaw, setShowModalRaw] = useState(false); // To control modal visibility
    const [showNotes, setShowNotes] = useState(false); // To control modal visibility
    const [showQuote, setShowModalQuote] = useState(false); // To control modal visibility
    const [selectedTender, setSelectedTender] = useState(null);
    const [showModalTask, setShowModalTask] = useState(false);
    const [showModalStages, setShowModalStages] = useState(false);
    const [modalHeading, setModalHeading] = useState('');
    const { rawProducts } = useSelector(state => state.rawProduct);
    const { tenders } = useSelector(state => state.tenders);
    const { customers } = useSelector(state => state.customers);
    const { products } = useSelector(state => state.finalProduct);

    console.log(type);
    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            let status;
            if (type == 'sale') {
                status = 0;
            } else if (type == 'cost') {
                status = 1;
            } else if (type == 'order') {
                status = 2;
            } else if (type == 'production') {
                status = 3;
            }
            const companyId = company.company?.id;
            dispatch(fetchTenders({ id: companyId, status: status }));
            dispatch(fetchCustomers(companyId));
            dispatch(fetchFinalProducts(companyId));
            dispatch(getProducts(companyId));
        }
    }, [dispatch, type]);

    const handleFormTaskSubmit = (formData) => {
        const company = JSON.parse(localStorage.getItem('company'));
        const companyId = company.company?.id;
        const updatedFormData = {
            ...formData,
            company_id: companyId,
        };


        dispatch(createTask(updatedFormData));
        setShowModalTask(false);
    };

    const handleFormSubmit = (formData) => {
        if (selectedTender && selectedTender?.id != null) {
            dispatch(updateTender({ id: selectedTender.id, tenderData: formData }));

        } else {
            const company = JSON.parse(localStorage.getItem('company'));
            const companyId = company.company?.id;
            dispatch(createTender({ id: companyId, tenderData: formData }));
        }
        setShowModal(false);
        window.location.reload();
    };


    const handleEditTax = (unitdata) => {
        setSelectedTender(unitdata);
        setModalHeading('Edit Tender') // Pass the supplier data to edit
        setShowModal(true);
    };

    const handleRawProduct = (data) => {
        setSelectedTender(data);
        setShowModalRaw(true);
    }

    const handleNotes = (data) => {
        setSelectedTender(data);
        setShowNotes(true);
    }

    const handleQuoteModel = (data) => {
        setSelectedTender(data);
        setShowModalQuote(true);
    }

    const handleTaskModal = (data) => {
        setSelectedTender(data);
        setShowModalTask(true);
    }

    const handleDelete = (taxId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Tender.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteTender(taxId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Tender has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };


    const calculateQuantity = (vendors) => {
        let finalQuantity = 0;
        vendors?.forEach((e) => {
            finalQuantity += e.quantity;
        });

        return finalQuantity;
    };

    const calculateRequired = (quantity, total, current) => {
        // console.log(quantity)
        // console.log(total)
        const requiredQuantity = (quantity * total) - current;
        if (requiredQuantity < 0) {
            return 0;
        }
        console.log('required', requiredQuantity);
        return requiredQuantity;
    };


    const handleUserDetail = (data) => {
        setSelectedTender(data);
        setShowCustomerModal(true);
    }


    const handleStatus = async (tenderData, tender_id, status) => {
        const checktask = await checkTaskIsPending(tender_id);
        if (checktask) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: `Please wait until the Tasks is completed for this tender`,
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            return;
        }

        if (type != 'sale' && (tenderData.final_cost === null || tenderData.final_cost === '' || tenderData.final_cost === 0)) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Update the Final Cost to push to Order',
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            return;
        }
        try {
            let deliveryDate = null;
            let comment = null;

            if (status == 6) {
                const { value: formValues } = await Swal.fire({
                    title: "Order Delivery Details",
                    html: `
                        <input type="date" id="delivery-date" className="form-control" placeholder="Delivery Date">
                        <input type="text" id="comment" className="form-control mt-3" placeholder="Comment">
                    `,
                    focusConfirm: false,
                    showCancelButton: true,
                    confirmButtonText: "Submit",
                    preConfirm: () => {
                        const deliveryInput = document.getElementById("delivery-date").value;
                        const commentInput = document.getElementById("comment").value;

                        if (!deliveryInput) {
                            Swal.showValidationMessage("Delivery date is required");
                        }

                        return { deliveryDate: deliveryInput, comment: commentInput };
                    }
                });

                if (!formValues) {
                    return; // Stop execution if the user cancels the input
                }

                deliveryDate = formValues.deliveryDate;
                comment = formValues.comment;
            }
            const response = await axios.post(`${API_URL}/tenders/push/cost-estimation`, {
                tender_id: tender_id,
                status: status,
                ...(status == 6 ? { delivery_date: deliveryDate, comment: comment } : {})
            });
            console.log("Purchase response:", response.data);

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: `Pushed ${status == 1 ? "for Cost estimation" : status == 6 ? "Order Deliver" : "to Orders"}`,
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            window.location.reload();
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something went wrong!',
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });

        }
    }

    const getisPurchased = (tenderData) => {
        const purchaseData = tenderData.finalProduct?.finalRawProducts
            .map((data) => ({
                tender_id: tenderData.id,
                rawProductId: data.raw_product_id,
                quantity: calculateRequired(tenderData.quantity, data?.quantity, calculateQuantity(data.rawProducts?.RawProductVendors)),
            }))
            .filter((product) => product.quantity > 0);
        console.log('is purhcase data', purchaseData);
        if (purchaseData.length === 0) {
            return false;
        }
        return true;
    }

    const handlePurchase = async (tenderData) => {

        const purchaseData = tenderData.finalProduct?.finalRawProducts
            .map((data) => ({
                tender_id: tenderData.id,
                rawProductId: data.raw_product_id,
                quantity: calculateRequired(tenderData.quantity, data?.quantity, calculateQuantity(data.rawProducts?.RawProductVendors)),
            }))
            .filter((product) => product.quantity > 0); // Only include products with requiredQuantity > 0

        // Only proceed if there are products with required quantity > 0
        if (purchaseData.length === 0) {
            alert("No products with required quantity to purchase");
            return;
        }
        const company = JSON.parse(localStorage.getItem('company'));
        const companyId = company.company?.id;
        // Prepare the payload to send to the API
        const payload = {
            purchaseData, // This is the array of products with tender_id, rawProductId, and quantity
            pushedByUserId: companyId, // Ensure userId is available in the component (or passed as prop)
        };

        try {
            // Send the data to your API
            const response = await axios.post(`${API_URL}/tenders/push/purchase`, payload);
            console.log("Purchase response:", response.data);

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Pushed to Purchase',
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            window.location.reload();
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something went wrong!',
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
        }
    };

    const handleStagesShow = (data) => {
        setSelectedTender(data);
        setShowModalStages(true);

    }

    // const statusColors = {
    //     "Sale request": "bg-primary",
    //     "Cost Estimation": "bg-info",
    //     "Order": "bg-warning",
    //     "In Purchase": "bg-secondary",
    //     "Ready to Production": "bg-dark",
    //     "Production": "bg-success",
    //     "Ready to Deliver": "bg-danger",
    //     "Delivered": "bg-success",
    // };

    let unitColumn;
    if (type === 'production') {
        unitColumn = [
            {
                name: '#',
                cell: (row, index) => index + 1,
                width: '40px' // Keep fixed width for serial numbers
            },
            {
                name: "Title",
                selector: row => row.title,
                sortable: true,
            },
            {
                name: 'Company',
                selector: row => row.customer?.company_name,
                sortable: true,
                wrap: true, // Allows text wrapping for auto width

            },
            {
                name: 'Product Name',
                selector: row => row.finalProduct?.name,
                sortable: true,
                wrap: true,
            },
            {
                name: 'Quantity',
                selector: row => row.quantity,
                sortable: true,
                wrap: true,
                width: "120px",
            },
            {
                name: 'Order Date',
                selector: row => moment(row.date).format('DD MMMM, YYYY'),
                sortable: true,
                wrap: true,
                width: "120px",
            },
            {
                name: 'Delivery Date',
                selector: row => moment(row.date).format('DD MMMM, YYYY'),
                sortable: true,
                wrap: true,
                width: "120px",
            },
            {
                name: 'Note',
                cell: row => {
                    <>
                        <button
                            className={`text-white btn btn-sm btn-success cursor-pointer me-1`}
                            data-tooltip-id="tooltip"
                            data-tooltip-content={"View Notes"}
                            onClick={() => handleNotes(row)}
                        >
                            <NotebookPen />
                        </button>
                    </>
                },
                sortable: true,
                wrap: true,
                width: "120px",
            },
            {
                name: 'Actions',
                cell: row => (
                    <>
                        {row.status == 4 && (<div className="float-end">
                            <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content={"Mark Production Complete"} onClick={() => {
                                handleStatus(row, row?.id, 5)
                            }}>
                                <ArrowRightFromLine />
                            </button>
                        </div>)}

                        <button
                            className="text-white btn btn-sm btn-success cursor-pointer me-1"
                            data-tooltip-id="tooltip"
                            data-tooltip-html={row.customer ? `
                                <strong>Name:</strong> ${row.customer.name}<br/>
                                <strong>Company:</strong> ${row.customer.company_name}<br/>
                                <strong>Phone:</strong> ${row.customer.phone}<br/>
                                <strong>Email:</strong> ${row.customer.email}<br/>
                                <strong>Address:</strong> ${row.customer.address}
                            ` : "No customer details available"}
                            onClick={() => handleUserDetail(row)}
                        >
                            <User />
                        </button>
                        <button
                            className={`text-white btn btn-sm ${getButtonColor(row.Tasks)} cursor-pointer me-1`}
                            data-tooltip-id="tooltip"
                            disabled={!row.Tasks || row.Tasks.length == 0 ? true : false}
                            data-tooltip-content={"Tasks"}
                            onClick={() => handleTaskModal(row)}
                        >
                            <Asterisk />
                        </button>
                        <span
                            className="text-white btn btn-sm btn-success cursor-pointer me-1"
                            data-tooltip-id="tooltip"
                            data-tooltip-content="View Raw Products"
                            onClick={() => handleRawProduct(row)}
                        >
                            <Eye />
                        </span>
                        <span
                            className="text-white btn btn-sm btn-success cursor-pointer me-1"
                            data-tooltip-id="tooltip"
                            data-tooltip-content="View Stages"
                            onClick={() => handleStagesShow(row)}
                        >
                            <TrendingUp />
                        </span>

                    </>
                ),
                width: "260px", // Ensure enough space for buttons
            }

        ];
    } else {
        unitColumn = [
            {
                name: '#',
                cell: (row, index) => index + 1,
                width: '40px' // Keep fixed width for serial numbers
            },
            {
                name: "Title",
                selector: row => row.title,
                sortable: true,
            },
            {
                name: 'Company',
                selector: row => row.customer?.company_name,
                sortable: true,
                wrap: true, // Allows text wrapping for auto width

            },
            {
                name: 'Contact Person',
                selector: row => (
                    <div>
                        <strong>{row.customer?.name}</strong><br />
                        <small>({row.customer?.phone})</small>
                    </div>
                ),
                sortable: true,
                wrap: true,
            },
            {
                name: 'Product Name',
                selector: row => row.finalProduct?.name,
                sortable: true,
                wrap: true,
            },
            {
                name: 'Quantity',
                selector: row => row.quantity,
                sortable: true,
                wrap: true,
                width: "120px",
            },
            {
                name: 'Actual Cost',
                selector: row => `₹ ${calculateActualCost(row.finalProduct, row.quantity)}`,
                sortable: true,
                wrap: true,
                width: "120px",
            },
            {
                name: 'Final Cost',
                selector: row => `₹ ${row.final_cost}`,
                sortable: true,
                wrap: true,
                width: "120px",
            },
            {
                name: 'Delivery Date',
                selector: row => moment(row.date).format('DD MMMM, YYYY'),
                sortable: true,
                wrap: true,
                width: "120px",
            },
            // {
            //     name: 'Actions',
            //     cell: row => (
            //         <>
            //             {type != 'production' && (

            //                 row.status === 3 ? (
            //                     <>
            //                         <div className="float-end">
            //                             <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content="Push to Production" onClick={() => handleStatus(row, row?.id, 3)}>
            //                                 <ArrowRightFromLine />
            //                             </button>
            //                         </div>
            //                     </>
            //                 ) : row.pushedForPurchase?.length > 0 && row.status === 2 ? (
            //                     <>
            //                         {row.pushedForPurchase[0].status == 1 || row.pushedForPurchase[0].status == 0 ?
            //                             (<span className={`badge text-white ${row.pushedForPurchase[0].status == 1 ? "bg-success" : "bg-danger"}`}>
            //                                 Pushed for Purchase
            //                             </span>) : (
            //                                 <span
            //                                     className="text-white btn btn-sm btn-success cursor-pointer me-1"
            //                                     data-tooltip-id="tooltip"
            //                                     data-tooltip-content="Pushed to Production"
            //                                     onClick={() => handleStatus(row, row.id, 3)}
            //                                 >
            //                                     <ArrowRightFromLine />
            //                                 </span>
            //                             )}
            //                         {/*  */}
            //                     </>
            //                 ) : (
            //                     <>
            //                         {row?.status == 0 && (<div className="float-end">
            //                             <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content={'Push for Cost Estimation'} onClick={() => handleStatus(row, row?.id, 1)}>
            //                                 <ArrowRightFromLine />
            //                             </button>
            //                         </div>)}
            //                         {row?.status == 1 && (<div className="float-end">
            //                             <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content="Push to Order" onClick={() => handleStatus(row, row?.id, 2)}>
            //                                 <ArrowRightFromLine />
            //                             </button>
            //                         </div>)}
            //                         {row?.status == 2 && (<div className="float-end">
            //                             <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content={getisPurchased(row) ? "Push to Purchase" : "Push to Production"} onClick={() => {
            //                                 const isPurchased = getisPurchased(row);
            //                                 if (isPurchased) {
            //                                     handlePurchase(row);
            //                                 } else {
            //                                     handleStatus(row, row?.id, 3)
            //                                 }
            //                             }}>
            //                                 <ArrowRightFromLine />
            //                             </button>
            //                         </div>)}
            //                         <span
            //                             className="text-white btn btn-sm btn-success cursor-pointer me-1"
            //                             data-tooltip-id="tooltip"
            //                             data-tooltip-html={row.customer ? `
            //                             <strong>Name:</strong> ${row.customer.name}<br/>
            //                             <strong>Company:</strong> ${row.customer.company_name}<br/>
            //                             <strong>Phone:</strong> ${row.customer.phone}<br/>
            //                             <strong>Email:</strong> ${row.customer.email}<br/>
            //                             <strong>Address:</strong> ${row.customer.address}
            //                         ` : "No customer details available"}
            //                             onClick={() => handleUserDetail(row)}
            //                         >
            //                             <User />
            //                         </span>
            //                         <span
            //                             className="text-white btn btn-sm btn-success cursor-pointer me-1"
            //                             data-tooltip-id="tooltip"
            //                             data-tooltip-content="View Raw Products"
            //                             onClick={() => handleRawProduct(row)}
            //                         >
            //                             <Eye />
            //                         </span>
            //                         <span
            //                             className="text-white btn btn-sm btn-warning cursor-pointer me-1"
            //                             data-tooltip-id="tooltip"
            //                             data-tooltip-content="Edit Sale Request"
            //                             onClick={() => handleEditTax(row)}
            //                         >
            //                             <Pen />
            //                         </span>
            //                         <span
            //                             className="text-white btn btn-sm btn-danger cursor-pointer"
            //                             data-tooltip-id="tooltip"
            //                             data-tooltip-content="Delete Sale Request"
            //                             onClick={() => handleDelete(row.id)}
            //                         >
            //                             <Delete />
            //                         </span>
            //                     </>
            //                 )
            //             )}
            //         </>
            //     ),
            //     width: "260px", // Ensure enough space for buttons
            // },
            {
                name: "Actions",
                width: "340px",
                cell: row => {
                    return (
                        <>
                            {row.status == 5 && (<div className="float-end">
                                <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content={"Deliver"} onClick={() => {
                                    handleStatus(row, row?.id, 6)
                                }}>
                                    <ArrowRightFromLine />
                                </button>
                            </div>)}
                            {row?.status === 0 && type === 'sale' && (<div className="float-end">
                                <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content={'Push for Cost Estimation'} onClick={() => handleStatus(row, row?.id, 1)}>
                                    <ArrowRightFromLine />
                                </button>
                            </div>)}
                            {row?.status == 1 && type === 'sale' && row?.cost_confirm == 'pending' && (<div className="float-end">
                                <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content="Confirm Cost" onClick={() => updateCostConfirm(row.id, 'confirm')}>
                                    <ArrowRightFromLine />
                                </button>
                            </div>)}
                            {row?.status == 1 && type === 'cost' && row?.cost_confirm == 'confirm' && (<div className="float-end">
                                <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content="Push to Order" onClick={() => handleStatus(row, row?.id, 2)}>
                                    <ArrowRightFromLine />
                                </button>
                            </div>)}
                            {(row?.status === 2 || row?.status === 3) && type == 'order' && (
                                <>
                                    {row.pushedForPurchase[0]?.status == 1 || row.pushedForPurchase[0]?.status == 0 ? (
                                        <span className={`badge text-white ${row.pushedForPurchase[0]?.status == 1 ? "bg-success" : "bg-danger"}`}>
                                            Pushed for Purchase
                                        </span>
                                    ) : (
                                        <div className="float-end">
                                            <button className="btn btn-primary btn-sm me-1" data-tooltip-id="tooltip" data-tooltip-content={getisPurchased(row) ? "Push to Purchase" : "Push to Production"} onClick={() => {
                                                const isPurchased = getisPurchased(row);
                                                if (isPurchased) {
                                                    handlePurchase(row);
                                                } else {
                                                    handleStatus(row, row?.id, 4)
                                                }
                                            }}>
                                                <ArrowRightFromLine />
                                            </button>
                                        </div>
                                    )}

                                </>
                            )}

                            {type == 'cost' && (<span
                                className="text-white btn btn-sm btn-warning cursor-pointer me-1"
                                data-tooltip-id="tooltip"
                                data-tooltip-content="Edit Sale Request"
                                onClick={() => handleEditTax(row)}
                            >
                                <Pen />
                            </span>)}

                            <button
                                className="text-white btn btn-sm btn-success cursor-pointer me-1"
                                data-tooltip-id="tooltip"
                                data-tooltip-html={row.customer ? `
                                    <strong>Name:</strong> ${row.customer.name}<br/>
                                    <strong>Company:</strong> ${row.customer.company_name}<br/>
                                    <strong>Phone:</strong> ${row.customer.phone}<br/>
                                    <strong>Email:</strong> ${row.customer.email}<br/>
                                    <strong>Address:</strong> ${row.customer.address}
                                ` : "No customer details available"}
                                onClick={() => handleUserDetail(row)}
                            >
                                <User />
                            </button>

                            {row.status != 6 && (<button
                                className={`text-white btn btn-sm ${getButtonColor(row.Tasks)} cursor-pointer me-1`}
                                data-tooltip-id="tooltip"
                                disabled={!row.Tasks || row.Tasks.length == 0 ? true : false}
                                data-tooltip-content={"Tasks"}
                                onClick={() => handleTaskModal(row)}
                            >
                                <Asterisk />
                            </button>)}
                            {row.status > 0 && (<span
                                className="text-white btn btn-sm btn-success cursor-pointer me-1"
                                data-tooltip-id="tooltip"
                                data-tooltip-content="Quotation Detail"
                                onClick={() => handleQuoteModel(row)}
                            >
                                <Quote />
                            </span>)}
                            <span
                                className="text-white btn btn-sm btn-success cursor-pointer me-1"
                                data-tooltip-id="tooltip"
                                data-tooltip-content="View Raw Products"
                                onClick={() => handleRawProduct(row)}
                            >
                                <Eye />
                            </span>
                            <span
                                className="text-white btn btn-sm btn-success cursor-pointer me-1"
                                data-tooltip-id="tooltip"
                                data-tooltip-content="View Stages"
                                onClick={() => handleStagesShow(row)}
                            >
                                <TrendingUp />
                            </span>



                        </>
                    )
                }
            }

        ];
    }


    const calculateActualCost = (selectedFinalProduct, qty) => {

        return (selectedFinalProduct.sale_cost * (selectedFinalProduct.gst_included ? 1 : (1 + (selectedFinalProduct.FinalCategory?.gst || 0) / 100))) * qty;
    }

    const updateCostConfirm = async (id, cost_confirm) => {
        Swal.fire({
            title: 'Update Cost Confirmation',
            text: 'Do you want to confirm or reject the cost?',
            icon: 'warning',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: 'Confirm',
            denyButtonText: 'Reject',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                // If confirmed, proceed directly
                await sendUpdateRequest(id, 'confirm');
            } else if (result.isDenied) {
                // If rejected, ask for a reason
                Swal.fire({
                    title: 'Reject Reason',
                    input: 'textarea',
                    inputPlaceholder: 'Enter the reason for rejection...',
                    inputAttributes: {
                        'aria-label': 'Enter the reason for rejection',
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Submit',
                    cancelButtonText: 'Cancel',
                    inputValidator: (value) => {
                        if (!value.trim()) {
                            return 'Rejection reason is required!';
                        }
                    },
                }).then(async (reasonResult) => {
                    if (reasonResult.isConfirmed) {
                        await sendUpdateRequest(id, 'rejected', reasonResult.value);
                    }
                });
            }
        });
    };

    // Helper function to send API request
    const sendUpdateRequest = async (id, status, reject_reason = null) => {
        try {
            const response = await axios.put(`${API_URL}/tenders/update/cost/confirm`, {
                id,
                cost_confirm: status,
                reject_reason
            });

            if (response) {
                Swal.fire(
                    status === 'confirm' ? 'Confirmed!' : 'Rejected!',
                    `Cost confirmation has been ${status}.`,
                    'success'
                );
                window.location.reload();
            }
        } catch (error) {
            console.error('Error updating cost_confirm:', error.response?.data || error.message);
            Swal.fire('Error!', 'Something went wrong. Please try again.', 'error');
        }
    };



    const getButtonColor = (tasks) => {
        const typetask = type == 'production' ? "Production" : "";
        if (!tasks || tasks.length == 0) return "bg-grey"; // No tasks

        if (tasks.some((task) => (typetask == "" || typetask == task.task_for) && (task.status === "pending"))) return "bg-danger"; // At least one pending
        if (tasks.some((task) => (typetask == "" || typetask == task.task_for) && (task.status === "in progress"))) return "bg-primary"; // At least one in progress
        if (tasks.every((task) => (typetask == "" || typetask == task.task_for) && (task.status === "completed"))) return "bg-success"; // All completed

        return "bg-grey"; // Default case
    };


    // const checkTaskIsPending = (tender_id) => {
    //     const typetask = type == 'production'?"Production":"";
    //     const tasks = tenders.findwhere(ttender_id);
    //     if (!tasks || tasks.length == 0) return false; // No tasks

    //     if (tasks.some((task) => typetask == "" || typetask == task.task_for && (task.status === "pending"))) return true; // At least one pending
    //     if (tasks.some((task) => typetask == "" || typetask == task.task_for && (task.status === "in progress"))) return true;

    //     return false; // Default case
    // };

    const checkTaskIsPending = (tender_id) => {
        const typetask = type === 'production' ? "Production" : "";

        // Find the tender with the matching tender_id
        const tender = tenders.find(tender => tender.id == tender_id);
        if (!tender || !tender.Tasks || tender.Tasks.length == 0) return false; // No tasks

        // Check if any task is pending or in progress
        return tender.Tasks.some(task =>
            (typetask == "" || typetask == task.task_for) &&
            (task.status === "pending" || task.status === "in progress")
        );
    };

    const handleAdd = () => {
        setSelectedTender([]);
        setModalHeading('Create Tender');// No supplier means we are adding a new one
        setShowModal(true);
    };



    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="text-primary mb-0">{type == 'sale' ? "Sale Request" : type == 'cost' ? "Cost Estimation" : type == 'order' ? "Sale Orders" : type == 'delivered' ? "Delivered Orders" : "Production Orders"}</h3>
                        {type == 'sale' && (<button
                            className="btn btn-primary"
                            onClick={() => handleAdd()}
                        >
                            + Add Request
                        </button>)}
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <DataTable
                            columns={unitColumn}
                            data={tenders.filter(tender => type == 'delivered' ? tender.status == 6 : tender.status !== 6)}
                            pagination
                            highlightOnHover
                            striped
                            customRowRender={(row) => (
                                <div
                                    data-tooltip-id={row.cost_confirm === "rejected" ? "tooltip" : undefined}
                                    data-tooltip-content={row.cost_confirm === "rejected" ? row.reject_reason : undefined}
                                    style={{
                                        backgroundColor: row.cost_confirm === "pending" ? "#007bff63" :
                                            row.cost_confirm === "confirm" ? "#28a74573" :
                                                "#ffcccc",
                                        color: "#000",
                                        cursor: row.cost_confirm === "rejected" ? "help" : "default",
                                        padding: "10px",
                                    }}
                                >
                                    {row.name} {/* Adjust based on what you want to show */}
                                </div>
                            )}
                            conditionalRowStyles={[
                                {
                                    when: row => type === 'cost' || type === 'sale',
                                    style: row => ({
                                        backgroundColor: row.cost_confirm === 'pending' ? '#007bff63' :  // Blue
                                            row.cost_confirm === 'confirm' ? '#28a74573' :  // Green
                                                '#ffcccc',  // Light red for rejected cost rows
                                        color: row.cost_confirm === 'pending' ? '#000' :  // Blue
                                            row.cost_confirm === 'confirm' ? '#000' :  // Green
                                                '#000', // Dark red text for better visibility
                                    }),
                                },
                            ]}

                            responsive
                            dense
                            customStyles={customTableStyles}
                        />
                    </div>
                </div>
            </div>


            <ShowStagesModal show={showModalStages} onClose={() => setShowModalStages(false)} heading={'Tender Stages'} initialData={selectedTender} />
            <CustomerDetailModal show={showModalCustomer} onClose={() => setShowCustomerModal(false)} heading={'Customer Detail'} initialData={selectedTender} />
            <NoteViewModal show={showNotes} onClose={() => setShowNotes(false)} heading={'Notes'} initialData={selectedTender} />
            <TenderRawProducts show={showRaw} onClose={() => setShowModalRaw(false)} heading={'Required raw Products'} initialData={selectedTender} />
            <QuotationDetailModel show={showQuote} onClose={() => setShowModalQuote(false)} heading={'Quotation Details'} initialData={selectedTender} />
            <CompanyTenderForm show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedTender} onSubmit={handleFormSubmit} customers={customers} products={products} rawProducts={rawProducts} type={type} />
            <CreateTaskModal show={showModalTask} onClose={() => setShowModalTask(false)} heading={'Task'} initialData={selectedTender} onSubmit={handleFormTaskSubmit} customers={customers} typetask={type == 'production' ? "Production" : ""} products={products} rawProducts={rawProducts} />

        </>
    );
}

export default CompanyTenders;
